import { ServiceSold } from '@/pages/protected/Sales/components/services-sold-table/services-sold-tables.types';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type TUserInfo = {
  sale: ServiceSold;
};

export const UserInfo = ({ sale }: TUserInfo) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-1">
      <div>
        <h4 className="text-sm font-medium text-gray-500">
          {t('sales.sections.userInfo.firstName')}
        </h4>
        <p>{sale.user.firstName}</p>
      </div>
      <div>
        <h4 className="text-sm font-medium text-gray-500">
          {t('sales.sections.userInfo.lastName')}
        </h4>
        <p>{sale.user.lastName}</p>
      </div>
      {/* TODO: Review if we want to show and edit user info. */}
      {/* <div>
        <Link
          to={`/clients/${sale.user.id}`}
          target="_blank"
          className="flex items-center gap-2 underline cursor-pointer text-primary"
        >
          {t('sales.sections.userInfo.moreInfo')}
          <ExternalLink className="w-4 h-4" />
        </Link>
      </div> */}
    </div>
  );
};
